import React from 'react';
import { Box, Flex, OutlineButton, Text } from '@cko/primitives';
import { trackEvent } from '@cko/dashboard-shared';
import styled from 'styled-components';

import { useNotifications } from '../../../contexts/NotificationsProvider';

const ERROR_VIEW_TEST_IDS = {
  reloadButton: 'notifications-in-navigation-error-view-reload-button',
  wrapper: 'notifications-in-navigation-error-view',
};

const Wrapper = styled(Flex)`
  align-items: center;
  flex-direction: column;
  flex-grow: 1;
  justify-content: center;
  margin: 0 auto;
  width: 322px;
`;

export const ErrorView = () => {
  const { fetchInitialNotifications } = useNotifications();

  const handleReloadButtonClick = async () => {
    trackEvent(
      'Click - in-dashboard notifications - reload button, fetch initial notifications in list',
      {},
    );
    await fetchInitialNotifications();
  };

  return (
    <Wrapper data-testid={ERROR_VIEW_TEST_IDS.wrapper}>
      <Box marginBottom="var(--layout-shoe)">
        <Text font="var(--heading-sm)">Couldn't load notifications</Text>
      </Box>
      <OutlineButton
        data-testid={ERROR_VIEW_TEST_IDS.reloadButton}
        onClick={handleReloadButtonClick}
      >
        Reload
      </OutlineButton>
    </Wrapper>
  );
};
